interface SectionHeadingProps {
  title: string;
  desc?: string;
  actionText?: string;
  onAction?: () => void;
  as?: "h2" | "h3";
}

export default function SectionHeading({
  title,
  desc,
  actionText,
  onAction,
  as = "h2",
}: SectionHeadingProps) {
  const Heading = as;
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
      <div className="flex items-center gap-3">
        <span className="h-6 w-1 rounded-full bg-primary-500" />
        <div>
          <Heading className="font-heading text-xl font-semibold text-foreground-950 md:text-2xl">
            {title}
          </Heading>
          {desc && (
            <p className="mt-1 text-xs text-foreground-500 md:text-sm">{desc}</p>
          )}
        </div>
      </div>
      {actionText && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="flex items-center gap-1 whitespace-nowrap text-sm text-foreground-500 transition-colors hover:text-primary-500 cursor-pointer"
        >
          {actionText}
          <i className="ri-arrow-right-s-line" />
        </button>
      )}
    </div>
  );
}